import React from 'react';
import { Button, Modal, ModalHeader, Input } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import CardBox from 'components/CardBox';
import FormErrors from 'components/formErrors/FormErrors';
import { isNameValid, isValueEntered } from 'services/Validation';
import { isDateBefore } from 'services/DateService';

class AddOrgSurvey extends React.Component {
    constructor(props) {
        super(props);
        this.handleStartDateClick = this.handleStartDateClick.bind(this);
        this.handleEndDateClick = this.handleEndDateClick.bind(this);

        const { id, surveyId, name, startDate, endDate } = props.orgSurvey;
        this.state = {
            id,
            surveyId,
            name,
            startDate,
            endDate,
            nameValid: isNameValid(name),
            idValid: isValueEntered(surveyId),
            startDateValid: isValueEntered(startDate),
            endDateValid: isValueEntered(endDate),
            formErrors: { surveyId: '', name: '', startDate: '', endDate: '', dates: '' },
            datesValid: false,
            formValid: false,
        };
    }

    componentDidMount() {
        this.validateForm();
    }

    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState(
            { [name]: value },
            () => { this.validateField(name, value); } // run this call back on state change
        );
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let idValid = this.state.idValid;
        let nameValid = this.state.nameValid;
        let startDateValid = this.state.startDateValid;
        let endDateValid = this.state.endDateValid;

        switch (fieldName) {
            case 'surveyId':
                idValid = isValueEntered(value);
                fieldValidationErrors.surveyId = idValid ? '' : ' is invalid';
                break;
            case 'name':
                nameValid = isNameValid(value);
                fieldValidationErrors.name = nameValid ? '' : ' is invalid';
                break;
            case 'startDate':
                startDateValid = isValueEntered(value);
                fieldValidationErrors.startDate = startDateValid ? '' : ' is invalid';
                break;
            case 'endDate':
                endDateValid = isValueEntered(value);
                fieldValidationErrors.endDate = endDateValid ? '' : ' is invalid';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            idValid: idValid,
            nameValid: nameValid,
            startDateValid: startDateValid,
            endDateValid: endDateValid,
        }, this.validateForm);
    }

    validateForm() {
        const datesAreValid = this.datesValid();
        this.setState({ formValid: this.state.idValid && this.state.nameValid && datesAreValid });
    }

    datesValid() {
        const { startDate, endDate } = this.state;
        let fieldValidationErrors = this.state.formErrors;
        if (isValueEntered(startDate) && isValueEntered(endDate)) {
            if (isDateBefore(endDate, startDate)) {
                fieldValidationErrors.dates = ' are invalid. The end date selected cannot be before the start date';
                this.setState({ formErrors: fieldValidationErrors });
                return false;
            }
            fieldValidationErrors.dates = '';
            this.setState({ formErrors: fieldValidationErrors });
            return true;
        }
        return false;
    }

    handleStartDateClick(day, { selected }) {
        const value = selected ? undefined : day;
        this.setState({ startDate: value },
            () => { this.validateField('startDate', value); });
    }

    handleEndDateClick(day, { selected }) {
        const value = selected ? undefined : day;
        this.setState({ endDate: value },
            () => { this.validateField('endDate', value); });
    }

    render() {
        const { onSaveOrgSurvey, showOrgSurveyLoader, onOrgSurveyClose, open, surveys } = this.props;
        const { id, surveyId, name, startDate, endDate } = this.state;
        const isNew = name === '';
        return (
            <Modal className="modal-box" toggle={onOrgSurveyClose} isOpen={open}>
                <ModalHeader className="modal-box-header bg-primary">
                    {isNew ? <IntlMessages id="orgSurvey.addOrgSurvey" /> :
                        <IntlMessages id="orgSurvey.saveOrgSurvey" />}
                    <span className="text-white pointer">
                        <i className="zmdi zmdi-close zmdi-hc-lg" onClick={onOrgSurveyClose} />
                    </span>
                </ModalHeader>

                <div className="modal-box-content">
                    <div className="row no-gutters">
                        <FormErrors formErrors={this.state.formErrors} />
                        <div className="col-lg-12 d-flex flex-column order-lg-1">
                            <Input
                                type="select"
                                name="surveyId"
                                id="surveySelect"
                                onChange={(event) => this.handleUserInput(event)}
                                className="form-control mb-2"
                                value={surveyId}
                            >
                                <option key='emptySelect'>-- select survey --</option>
                                {surveys.map((survey) => {
                                    return <option key={survey.id} value={survey.id}>{survey.name}</option>;
                                })}
                            </Input>
                            <input type="text" className="form-control mb-2"
                                placeholder="Survey Name"
                                onChange={(event) => this.handleUserInput(event)}
                                defaultValue={name} name="name"
                            />
                            <div className="row">
                                <CardBox styleName="col-lg-6 col-sm-6" heading={<IntlMessages id="orgSurvey.addOrgSurveyStartDate" />}>
                                    <DayPicker
                                        selectedDays={startDate}
                                        onDayClick={this.handleStartDateClick}
                                    />
                                </CardBox>
                                <CardBox styleName="col-lg-6 col-sm-6" heading={<IntlMessages id="orgSurvey.addOrgSurveyEndDate" />}>
                                    <DayPicker
                                        selectedDays={endDate}
                                        onDayClick={this.handleEndDateClick}
                                    />
                                </CardBox>
                            </div>
                        </div>
                    </div>

                    <div className="modal-box-footer d-flex flex-row">
                        <Button className="text-uppercase" disabled={!this.state.formValid} color="primary" onClick={() => {
                            showOrgSurveyLoader();
                            onOrgSurveyClose();
                            onSaveOrgSurvey(
                                {
                                    'name': name,
                                    'id': id,
                                    'surveyId': surveyId,
                                    'startDate': startDate,
                                    'endDate': endDate,
                                });
                            this.setState({
                                name: '',
                                id: '',
                                surveyId: '',
                                startDate: '',
                                endDate: '',
                                formErrors: { surveyId: '', name: '', startDate: '', endDate: '', dates: '' },
                                datesValid: false,
                                formValid: false,
                            });

                        }}>
                            {isNew ? <IntlMessages id="orgSurvey.addOrgSurvey" /> :
                                <IntlMessages id="orgSurvey.saveOrgSurvey" />}</Button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default AddOrgSurvey;


// WEBPACK FOOTER //
// ./components/Agile/OrgSurvey/AddOrgSurvey/index.js